<template>
    <div v-if="value" class="msg-group-wrapper">
        <div class="flex-center-hori">
            <div v-for="str in value.title" :key="str" class="welcoming-top">{{str}}</div>
            <div v-if="value.tag">
                <div v-for="str in value.tag" :key="str" class="welcoming-tag">{{str}}</div
            ></div>
        </div>
        <div class="msg-wrapper">
            <div class="msg-placeholder">
                <img @click="clickAvatar">
            </div>
            <div class="msg-content-box ai-msg-box">
                <div class="ai-msg">
                    <div class="ai-msg-content">
                        <div v-for="str in value.introduction" :key="str" class="welcoming-title">{{str}}</div>
                        <div v-for="str in value.features" :key="str" class="welcoming-list-item">
                            <div class="list-dot"></div>
                            <div class="list-text">{{str}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="msg-placeholder">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'MsgWelcome',
    data () {
        return { };
    },
    props: {
        value: {
            type: Object,
            default: null
        },
        chat: {
            type: Object,
            default: null
        }
    },
    methods: {
        clickAvatar () {
            this.$bus.$emit('digital-human:toggle', {});
        }
    }
};
</script>
<style scoped lang="scss">
.welcoming-top {
    font-size: 32px;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: bold;
    color: var(--msg-welcome-title-color);
    line-height: 48px;
    background: var(--msg-welcome-title-color-gradient);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 32px 0;
}
.welcoming-tag{
    padding: 0 12px;
    margin: 6px 0 0 8px;
    height: 32px;
    background: linear-gradient(270deg, #165DFF 0%, #209BFF 100%);
    border-radius: 4px;
    font-size: 16px;
    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 32px;
}
.msg-placeholder{
    text-align: center;
    img {
        content: var(--assistant-avatar);
        margin-top: 8px;
    }
}

.ai-msg {
    box-sizing: border-box;
    width: 100%;
    border-radius: 8px;
    padding: 10px 24px 24px;
    background: var(--msg-welcome-ai-bg);
    background-size: cover;

    .welcoming-title {
        width: 100%;
        font-size: 20px;
        font-family: PingFang SC-Medium, PingFang SC, SourceHanSansSC-Medium, SourceHanSansSC, Microsoft Yahei;
        font-weight: 500;
        color: var(--msg-welcome-ai-title-color);
        line-height: 30px;
        margin: 8px 0 8px 0;
    }

    .welcoming-list-item {
        width: 100%;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;

        >.list-dot {
            width: 4px;
            height: 4px;
            background: var(--msg-welcome-ai-dot-color);
            border-radius: 4px;
            margin: 10px 8px
        }

        >.list-text {
            font-size: 16px;
            color: var(--msg-common-text-color);
            opacity: 0.65;
            line-height: 26px;
        }
    }
}
</style>
